export interface MurphyBasicCustomerDto {
	Id: string
	Name: string
	CustomerGroupName: string
	ExternalContactsEnabled: boolean
	ActiveProductIds: number[]
	IsFreemium: boolean
}

export interface CustomerBasicInfoDTO {
	Id: string
	Name: string
}

export interface CustomerGroupDto {
	ID: number
	Name: string
}

export interface CustomersSelectedDTO {
	Id: string
	Enabled: boolean
}

export interface UpdateGroupCustomerRequest {
	CustomerUserId: string
	CustomerId: string
	CustomerIds: CustomersSelectedDTO[]
	UserId: string
}

export interface ICustomersApi {
	getCustomers: () => Promise<MurphyBasicCustomerDto[]>
	getCustomersMobile: () => Promise<MurphyBasicCustomerDto[]>
	getCustomer: (customerId: string) => Promise<MurphyBasicCustomerDto>
	getChildCustomers: (customerId: string) => Promise<MurphyBasicCustomerDto[]>
	getCustomerIsParent: (customerId: string) => Promise<boolean>
	updateGroupCustomer: (updateGroupCustomerRequest: UpdateGroupCustomerRequest) => Promise<CustomerBasicInfoDTO[]>
}

const CustomersApiType = {
	ICustomersApi: Symbol("ICustomersApi")
}

export default CustomersApiType
